import React from "react";
import FilterRow from "./FilterRow";
import {FaUnlink, FaSitemap, FaSpider, FaLink} from "react-icons/fa";

export const OrphanFilter = ({handleSwitchToggle, state}) => {
    const t = state.toggles;
    return (
        <FilterRow
            label="Discoverability"
            items={[
                {label: "Orphan pages", icon: FaUnlink, color: "#ef4444", checked: t.isOrphanChecked, onChange: handleSwitchToggle("isOrphanChecked"), key: "orphan"},
                {label: "Missing in sitemap", icon: FaSitemap, color: "#f59e0b", checked: t.isMissingInSitemapChecked, onChange: handleSwitchToggle("isMissingInSitemapChecked"), key: "missingInSitemap"},
                {label: "Missing in crawl", icon: FaSpider, color: "#8b5cf6", checked: t.isMissingInCrawlChecked, onChange: handleSwitchToggle("isMissingInCrawlChecked"), key: "missingInCrawl"},
                {label: "Discoverable", icon: FaLink, color: "#10b981", checked: t.isDiscoverableChecked, onChange: handleSwitchToggle("isDiscoverableChecked"), key: "isDiscoverable"},
            ]}
        />
    );
};
